module.exports = __webpack_public_path__ + "assets/img/home_1.eb3b33cc.jpg";